import request from "../../utils/NetWorkUtil";

export async function getHotRank() {
    return request('/api/news', {
        method: 'GET',
        headers: {
            Accept: 'application/json,version=2'
        }
    });
}
